// import {
//   FacebookIcon,
//   GithubIcon,
//   LinkedinIcon,
//   TwitterIcon,
// } from "lucide-react";
import React from "react";
import img from "../constant";
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import { Link } from "react-router-dom";
// import { LogoIcon, TwitterIcon, LinkedInIcon, GithubIcon, FacebookIcon } from './icons/Icons';

interface FooterLink {
  name: string;
  href: string;
}

interface FooterSection {
  title: string;
  links: FooterLink[];
}

const footerSections: FooterSection[] = [
  {
    title: "Product",
    links: [
      { name: "AI Interviews", href: "#" },
      { name: "Smart Scheduling", href: "#" },
      { name: "Behavioral Insights", href: "#" },
      { name: "Reports & Analytics", href: "#" },
      { name: "Pricing", href: "#" },
    ],
  },
  {
    title: "Resources",
    links: [
      { name: "90-Sec Demo", href: "/request" },
      // { name: "Case Study", href: "/case-study" },
      // { name: "ROI Calculator", href: "#" },
      // { name: "Help Center / Guides", href: "#" },
      // { name: "Changelog & Roadmap", href: "#" },
    ],
  },
  {
    title: "Security & Trust",
    links: [
      { name: "Trust Center", href: "/trust-center" },
      { name: "Data Encryption", href: "/data-encryption" },
      // { name: "Access Controls & Audit Trails", href: "#" },
      // { name: "Sub-processors", href: "#" },
    ],
  },
  {
    title: "Company",
    links: [
      { name: "About", href: "https://25thandstaffing.com/origin" },
      { name: "Contact", href: "https://25thandstaffing.com/talk-to-us" },
    ],
  },
  {
    title: "Legal",
    links: [
      { name: "Terms of Service", href: "/terms" },
      { name: "Privacy Policy", href: "/policy" },
      { name: "Data Processing Addendum", href: "/dpa" },
      { name: "Cookie Policy", href: "/cookie-policy" },
      // { name: "Responsible AI", href: "#" },
    ],
  },
];

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#000E43] text-[white] font-abel">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 md:py-12 py-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8 gap-3">
          <div className="space-y-4 xl:col-span-1">
            <Link to={`/`}>
              <div className="flex items-center space-x-3">
                <img
                  src={img.logoWhite}
                  alt="logo"
                  className="md:w-[75px] w-[55px]"
                />
                <span className="text-2xl font-bold text-white">
                  AI Recruiter
                </span>
              </div>
            </Link>
            <p className="text-base">
              Hiring with intelligent automation and deep insights
            </p>
            <div className="flex flex-wrap justify-start items-center">
              <div className="p-1 border mx-1 rounded-full border-[white] cursor-pointer hover:border-[#243677]">
                <a
                  href="https://mobile.twitter.com/25thstaffing"
                  target="__blank"
                  rel="noreferrer"
                >
                  <FaTwitter color="#fff" fontSize="1.5rem" />
                </a>
              </div>
              <div className="p-1 border mx-1 rounded-full border-[#ffffff] cursor-pointer hover:border-[#243677]">
                <a
                  href="https://m.facebook.com/people/25th-and-Staffing/100065267672006/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebook color="#ffffff" fontSize="1.5rem" />
                </a>
              </div>
              <div className="p-1 border mx-1 rounded-full border-[#ffffff] cursor-pointer hover:border-[#243677]">
                <a
                  href="https://www.instagram.com/25thandstaffing_official"
                  target="__blank"
                  rel="noreferrer"
                >
                  <FaInstagram color="#ffffff" fontSize="1.5rem" />
                </a>
              </div>
              <div className="p-1 border mx-1 rounded-full border-[#ffffff] cursor-pointer hover:border-[#243677]">
                <a
                  href="https://ng.linkedin.com/company/25thandstaffing-com"
                  target="__blank"
                  rel="noreferrer"
                >
                  <FaLinkedin color="#ffffff" fontSize="1.5rem" />
                </a>
              </div>
            </div>
          </div>
          <div className="mt-12 grid grid-cols-2 md:gap-8 gap-3 md:grid-cols-4 xl:mt-0 xl:col-span-2">
            {/* <div className="md:grid md:grid-cols-2 md:gap-8 col-span-2"> */}
            <div className="md:mt-0">
              <h3 className="text-sm font-semibold tracking-wider uppercase text-white">
                Resources
              </h3>
              <ul className="mt-4 space-y-4">
                {footerSections[1].links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-base hover:text-white transition-colors duration-200"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold tracking-wider uppercase text-white">
                Security & Trust
              </h3>
              <ul className="mt-4 space-y-4">
                {footerSections[2].links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-base hover:text-white transition-colors duration-200"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            {/* </div> */}
            {/* <div className="md:grid md:grid-cols-2 md:gap-8 col-span-2 md:col-span-1"> */}
            <div className="mt-4 md:mt-0">
              <h3 className="text-sm font-semibold tracking-wider uppercase text-white">
                Company
              </h3>
              <ul className="mt-4 space-y-4">
                {footerSections[3].links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-base hover:text-white transition-colors duration-200"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="mt-4 md:mt-0">
              <h3 className="text-sm font-semibold tracking-wider uppercase text-white">
                Legal
              </h3>
              <ul className="mt-4 space-y-4">
                {footerSections[4].links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-base hover:text-white transition-colors duration-200"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            {/* </div> */}
          </div>
        </div>
        {/* <div className="mt-12 border-t border-slate-700 pt-8">
          <h3 className="text-sm font-semibold tracking-wider uppercase text-white">
            Legal
          </h3>
          <ul className="mt-4 space-y-4 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-8 sm:gap-y-4 lg:grid-cols-4">
            {footerSections[4].links.map((link) => (
              <li key={link.name}>
                <a
                  href={link.href}
                  className="text-base hover:text-white transition-colors duration-200"
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div> */}
        <div className="mt-8 border-t border-slate-700 pt-4 md:flex md:items-center md:justify-between">
          <p className="text-base md:order-1">
            &copy; {new Date().getFullYear()} 25th &amp; Staffing | All rights
            reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
